import { render } from "./SayForm.vue?vue&type=template&id=5a955dd2"
import script from "./SayForm.vue?vue&type=script&lang=js"
export * from "./SayForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__